/**
 *
 * @module Entry
 * @desc Main entry point for plugins
 *
 */

/* Import Advertising Plugins */
export { default as BaseAdvertisingPlugin } from './advertising/base-advertising-plugin';
export { default as AdvertisingPluginEvents } from './advertising/advertising-plugin-events';
export { default as FreewheelPlugin } from './advertising/freewheel/freewheel-plugin';
export { default as DfpPlugin } from './advertising/dfp/dfp-plugin';

/* Import Communication Plugins */
export { default as Communication } from './comm/communication';

/* Import Analytics Plugins */
export { default as AnalyticsPluginEvents } from './analytics/analytics-plugin-events';
export { default as OmniturePlugin } from './analytics/omniture/omniture-plugin';
export { default as ChartBeatPlugin } from './analytics/chartbeat/chartbeat-plugin';
export { default as ConvivaPlugin } from './analytics/conviva/conviva-plugin';
